import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './DesignationItem.module.scss';
import { URLS } from '@/constants/urls';

export const DesignationItem = ({ title, color, isChecked, onClick }) => {
  const { t } = useTranslation();
  const isMobile = useScreenSizeContext().isMobile;

  const titleClassName = [
    styles.title,
    isChecked && styles.checked,
  ].filter(Boolean).join(' ');

  return (
    <div className={styles.container} key={title} data-test-id="designation-item" data-rbf="designation-item">
      <div className={styles.content}>
        {!isMobile && !isChecked ? (
          <img
            className={styles.icon}
            src={URLS.PRIMEUR_NOTIF}
            alt="notification"
            height={14}
            width={14}
          />
        ) : (
          isChecked ? (
            <img
              className={styles.icon}
              src={URLS.ICON_CHECKMARK_GREEN}
              alt="checkmark"
              height={14}
              width={14}
            />
          ) : null
        )}
        <p className={titleClassName}>{`${title}${color ? ' - ' + color : ''}`}</p>
      </div>
      {isChecked ? (
        <img
          onClick={onClick}
          src={URLS.ORION_CLOSE_BLACK}
          className={styles.unchecked}
          alt="close"
          height={14}
          width={14}
        />
      ) : (
        !isMobile ? (
          <CallToActionContainer
            onClick={onClick}
            className={styles.button}
          >
            {t('alert.register')}
          </CallToActionContainer>
        ) : (
          <div
            className={styles['mobile-button']}
            onClick={onClick}
          >
            <img
              src={URLS.WHITE_ICON_ADD}
              alt="add"
              height={16}
              width={16}
            />
          </div>
        )
      )}
    </div>
  );
};

DesignationItem.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default DesignationItem;
